import { createSelector } from '@ngrx/store';
import { orderBy } from 'lodash';
// Merge analyze and channel messages.
// For Optimistic, ui message stayed and duplicate new data will removed for no array reference change until refresh.
// there is single analyze data. Data splitted like sender and receiver
export const getChannelAndAnalyzeMessages = createSelector(
  state => state['aiAssistant']?.analyzeMessages,
  state => state['aiAssistant']?.channelMessages,
  (analyzeMessages, channelMessages) => {
    const receiverAnalyzeMessages = (analyzeMessages ?? []).map(m => {
      if (m.data) {
        const { message, ...restData } = m.data;
        return { ...m, data: restData };
      }
      return m;
    });
    const splitAnalyzeMessages = orderBy(([...(analyzeMessages ?? []), ...(receiverAnalyzeMessages ?? [])])?.filter(message => message.identifier === 'data-source-analyze' && message.status === 'completed'), [(b) => new Date(b.createdDate), (b) => !!b.data?.message], ['asc', 'desc']);
    const updatedAnalyzeMessages = splitAnalyzeMessages.map(analyzeMessage => {
      if (analyzeMessage.data?.message) {
        return {
          ...analyzeMessage,
        };
      } else {
        const maxLevelObj = analyzeMessage?.data?.summarized?.filter(i => i.level === Math.max(...analyzeMessage?.data?.summarized.map(x => x.level)))?.reduce((a, b) => new Date(a.date) > new Date(b.date) ? a : b);
        const summary = analyzeMessage?.data?.summarized?.filter(item => item.level === 1);
        const lastResult = maxLevelObj?.result;
        return {
          ...analyzeMessage,
          aiFunctionId: "ragsearch",
          status: "new",
          data: {
            // Use the last summary result, or the error, or a default error
            answerAsMarkdown: lastResult ? lastResult : analyzeMessage?.error?.message ? analyzeMessage?.error?.message : `I searched the relevant documents but couldn't find a definitive answer. Can you give more specifics or ask in a different way`,
            // Use the rest of the summary as additional messages
            additionalMessages: summary
          },
          senderId: "00000000-0000-0000-0000-000000000001",
        };
      }
    });
    const allMessages = {
      private: orderBy([...(channelMessages?.private ?? []), ...(updatedAnalyzeMessages ?? [])],
        [(b) => new Date(b.createdDate), (b) => !!b.data?.message], ['asc', 'desc'])
    };

    function removeDuplicate(data: any[]): any[] {
      const grouped: Record<string, any[]> = data.reduce((acc, item) => {
        (acc[item.correlationId] ||= []).push(item);
        return acc;
      }, {} as Record<string, any[]>);

      const result: any[] = [];

      Object.values(grouped).forEach(group => {
        const hasTemporary = group.some(x => x.temporary === true);
        if (!hasTemporary) {
          result.push(...group);
          return;
        }
        const first = group.find(x => x.temporary === true)!;
        const cleanedGroup = group.filter(
          x => !(x.data && x.data.datasources)
        );
        const second = cleanedGroup.find(x => x !== first);
        result.push(first);
        if (second) result.push(second);
      });
      return orderBy(
        result,
        [
          (item) => new Date(item.createdDate).getTime(),
          (item) => item.data?.message ? 0 : 1
        ],
        ['asc', 'asc']
      );
    }

    const result = {
      private: removeDuplicate(allMessages.private)
    }
    return result;
  }
);
